import {
  DEFAULT_ROUTES,
  isContractManagementReleased,
  usePrivateOfficeCreateRoute,
} from "./routes";

export const useHeaderItems = () => {
  const createRoute = usePrivateOfficeCreateRoute();

  return [
    {
      title: "Painel",
      link: DEFAULT_ROUTES.INDEX,
      breadcrumbName: "index",
      submenu: [],
    },
    {
      title: "Escritórios Privativos",
      link: "private-office",
      breadcrumbName: "private-office",
      submenu: [
        ...(import.meta.env.VITE_PO_CONTRACTS_RELEASED != "false" //@TODO: remove this after contracts released
          ? [
              {
                title: "Contratos de venda",
                link: DEFAULT_ROUTES.PRIVATE_OFFICE_CONTRACTS_LIST,
                breadcrumbName: "contracts",
              },
            ]
          : []),
        {
          title: "Bookings",
          link: DEFAULT_ROUTES.PRIVATE_OFFICE_BOOKINGS,
          breadcrumbName: "bookings",
        },
        {
          title: "Gerenciar Alterações",
          link: DEFAULT_ROUTES.PRIVATE_OFFICE_UPDATE_REQUESTS,
          breadcrumbName: "update-requests",
        },
        {
          title: "Criar nova sala privativa",
          link: createRoute,
          breadcrumbName: "new-private-rooms",
          target: "_blank",
        },
        {
          title: "Criar nova proposta customizada",
          link: `${import.meta.env.VITE_NEW_WOBA_ORDERS_URL}orders/new`,
          breadcrumbName: "new-order",
          target: "_blank",
          isNew: true,
        },
        {
          title: "List Pre-Booking",
          link: `${import.meta.env.VITE_OLD_BACKOFFICE_URL}#/prebookinglist`,
          breadcrumbName: "list-pre-booking",
          target: "_blank",
        },
        {
          title: "Image audit",
          link: `${import.meta.env.VITE_OLD_BACKOFFICE_URL}#/privateroom-image-audit`,
          breadcrumbName: "image-audit",
          target: "_blank",
        },
        {
          title: "Coworking Spaces with TP",
          link: `${import.meta.env.VITE_PORTAL_URL}/private/mapview`,
          breadcrumbName: "coworking-spaces-with-tp",
          target: "_blank",
        },
        {
          title: "Demand Heatmap by Neighborhood",
          link: `${import.meta.env.VITE_OLD_BACKOFFICE_URL}#/demand-heatmap`,
          breadcrumbName: "demand-heatmap-by-neighborhood",
          target: "_blank",
        },
        {
          title: "Proposal Generator",
          link: "https://automations.woba.com.br/proposal",
          breadcrumbName: "proposal-generator",
          target: "_blank",
        },
        {
          title: "Demonstração Parceiro",
          link: DEFAULT_ROUTES.PARTNER_DEMO,
          breadcrumbName: "partner-demo",
        },
        {
          title: "Área administrativa",
          link: DEFAULT_ROUTES.PRIVATE_OFFICE_ADMIN,
          breadcrumbName: "admin",
        },
        {
          title: "Vision",
          link: DEFAULT_ROUTES.VISION_360_PROPOSALS,
          breadcrumbName: "vision",
        },
      ],
    },
    {
      title: "Contratos",
      link: "contracts",
      breadcrumbName: "contracts",
      submenu: [
        {
          title: "Novo Contrato",
          link: `${import.meta.env.VITE_OLD_BACKOFFICE_URL}#/contracts/new`,
          breadcrumbName: "new-contract",
          target: "_blank",
        },
        {
          title: "Listagem",
          link: `${import.meta.env.VITE_OLD_BACKOFFICE_URL}#/contracts/list`,
          breadcrumbName: "contract-list",
          target: "_blank",
        },
        {
          title: "Pagamentos",
          link: `${import.meta.env.VITE_OLD_BACKOFFICE_URL}#/payments/list`,
          breadcrumbName: "payments-list",
          target: "_blank",
        },
        {
          title: "License Fee",
          link: DEFAULT_ROUTES.LICENSE_FEE_LIST,
          breadcrumbName: "license-fee",
        },
      ],
    },
    {
      title: "Visitas",
      link: DEFAULT_ROUTES.INDEX,
      breadcrumbName: "visits",
      submenu: [],
    },
    ...(isContractManagementReleased()
      ? [
          {
            title: "Gestão Contratual",
            link: DEFAULT_ROUTES.CONTRACT_MANAGEMENT,
            breadcrumbName: "contract-management",
            submenu: [],
            isNew: true,
          },
        ]
      : []),
  ];
};
